<template>
    <div id="fixedHeader" class="fixed-header" :class="{ 'home-lobby-header': $route.name === 'Home', 'home-lobby-header--signed-in': isLogin && $route.name === 'Home' }">
        <statusBar></statusBar>
        <div v-if="isShowDownAppNav && false" class="downApp">
            <div class="icon-close" @click="onCloseDownAppNav">
                <i class="iconfont icon-s-cuowu-guanbi"></i>
            </div>
            <div class="tips">{{ domainKey }} {{ $t("footer.ApplicableTo") }} {{ sysPlatform == 'Windows' ? 'Windows' :
                            (sysPlatform == 'ios' ? 'IOS' : 'Android') }}</div>
            <!-- <div class="tips">
                <span>{{ $t("home.DownloadTips") }}</span>
                <span class="money">{{ CurrencyType }}100</span>
            </div> -->
            <div class="btn" @click="onShowDownAppPopup">
                <i class="iconfont icon-shouji"></i>
                <span>{{ $t("home.Download") }}</span>
            </div>
        </div>
        <div class="pages-header">
            <div class="area_left">
                <button type="button" class="icon_toggle" :aria-label="$t('tabbar.menu')" @click="toggleSideBar">
                    <AuroraArtIcon name="menu" />
                </button>
                <!-- <i class="icon_toggle iconfont icon-caidanshouqi" :class="{'sidebarOpened': sidebar.opened}" @click="toggleSideBar"></i> -->
                <div v-if="device !== 'mobile'" class="down_box" @click="onShowDownAppPopup">
                    <div class="down_img">
                        <AuroraIcon name="monitor" />
                    </div>
                    <div class="down_info">
                        <div>{{ $t("downApp.ApplicableWindows") }}</div>
                        <div>{{ $t("downApp.ApplicableWindowsTips") }}</div>
                    </div>
                </div>
            </div>
            <div v-if="device !== 'mobile' && $route.name !== 'Home'" class="search_btn" @click.stop="toSearch" >
                <AuroraIcon name="search" />
                <div class="txt"> {{ $t("home.SearchGames") }}</div>
            </div>
            <nav v-if="device !== 'mobile' && isShowSport" class="header-sports-tabs"><button type="button" :class="{ act: !isIntoSport }" @click="onPageRefresh">{{ $t('sports.home') }}</button><button type="button" :class="{ act: isIntoSport }" @click="toSports">{{ $t('sports.title') }}</button></nav>
            <div class="icon_logo" :class="{'mobile_logo': device == 'mobile'}">
                <img v-if="device == 'mobile'" class="logo" :src="logoUrl2" @click.stop="onPageRefresh" />
                <img v-else class="logo" :src="logoUrl" @click.stop="onPageRefresh" />
            </div>
            <div class="user_action">
                <div></div>
                <div>
                    <div v-if="isLogin && $route.name === 'Home'" class="header-home-wallet" :aria-label="$t('person.Balance')">
                        <div class="header-wallet-balance">
                            <div class="header-wallet-value" :title="CurrencyType + allBalance" role="button" tabindex="0" @click.stop="$store.dispatch('user/setIsShowBalancePopup', true)" @keydown.enter="$store.dispatch('user/setIsShowBalancePopup', true)" @keydown.space.prevent="$store.dispatch('user/setIsShowBalancePopup', true)"><small>{{ CurrencyType }}</small><strong>{{ allBalance }}</strong></div>
                            <button type="button" class="header-wallet-refresh" :aria-label="$t('person.Balance')" :aria-busy="isRefreshingMoney" :disabled="isRefreshingMoney" @click.stop="getUserInfo"><AuroraIcon name="refresh" :class="{ turning: isRefreshingMoney }" /></button>
                        </div>
                        <div class="header-wallet-actions">
                            <button type="button" class="header-wallet-deposit" :aria-label="$t('deposit.Deposit')" :title="$t('deposit.Deposit')" @click.stop="toDeposit"><AuroraIcon name="wallet" /></button>
                        </div>
                    </div>
                    <div v-if="isLogin && device === 'mobile' && $route.name !== 'Home'" class="user_info">
                        <div class="balance-refresh" :class="{'turning':isRefreshingMoney}" @click.stop="getUserInfo"><AuroraIcon name="refresh" /></div>
                        <div class="user_money" @click.stop="$store.dispatch('user/setIsShowBalancePopup', true)">
                            {{ CurrencyType }}{{ allBalance }}
                        </div>
                        <div class="deposit" :aria-label="$t('deposit.Deposit')" @click.stop="toDeposit"><AuroraIcon name="wallet" /></div>
                    </div>
                    <div v-if="isLogin && device !== 'mobile' && $route.name !== 'Home'" class="user_info_pc" @click.stop="toMy">
                        <AuroraArtIcon class="u_avatar" name="account" />
                        <div class="u-info">
                            <div>Hi, {{ userPhone }}</div>
                            <div>ID:{{ userInfo.id }}</div>
                        </div>
                        <AuroraIcon class="u-arrow" name="chevron" />
                    </div>
                    <div v-if="!isLogin" class="user_login">
                        <div class="sign_up" @click="toLogin(1)">{{ $t("login.SignUp") }}</div>
                        <div class="login" @click="toLogin(2)">{{ $t("login.SignIn") }}</div>
                    </div>
                </div>
            </div>
        </div>
        <logoutPopup ref="logoutPopup"></logoutPopup>
        <!-- <BonusTransferPopup ref="BonusTransferPopup" @confirm="isLogin && getUserInfo()"></BonusTransferPopup> -->
    </div>
</template>

<script>
import { domainKey } from '@/common/http'
import AuroraIcon from '@/components/auroraIcon'
import AuroraArtIcon from '@/components/auroraIcon/artIcon.vue'
import statusBar from '@/components/statusBar'
import logoutPopup from '@/components/logoutPopup'
import { mapState } from 'vuex'
import { getUserInfo } from '@/api/user'
import { isPWA, getPlatform } from '@/utils'
import { Toast } from 'vant'
let savedPwaPrompt888 = null
// import BonusTransferPopup from '@/components/BonusTransferPopup'
export default {
    name: 'Header',
    components: { statusBar, logoutPopup, AuroraIcon, AuroraArtIcon },
    data() {
        return {
            sysPlatform: getPlatform(),
            domainKey,
            pathAct: '',
            isRefreshingMoney: false
        }
    },
    computed: {
        ...mapState({
            device: state => state.app.device,
            sidebar: state => state.app.sidebar
        }),
        isLogin() {
            return !!this.$store.getters.token
        },
        logoUrl() {
            return this.$store.getters.sysConfig?.homeLogoUrl
        },
        logoUrl2() {
            return this.$store.getters.sysConfig?.homeImageUrl
        },
        userInfo() {
            return this.$store.getters.userInfo
        },
        userPhone() {
            const phone = this.userInfo && this.userInfo.phone
            return phone ? this.maskNumber(phone) : ''
        },
        isShowDownAppNav() {
            const isShowDownAppNav = Number(this.$store.state.system.isShowDownAppNav)
            // let downType = this.$store.state.vuex_sysConfig && this.$store.state.vuex_sysConfig.downType || 'apk'
            return isShowDownAppNav === 1 && (!isPWA()) && getPlatform() !== 'android' && getPlatform() !== 'Android' && getPlatform() !== 'ios'
        },
        noticeNumber() {
            return this.$store.getters.noticeNumber
        },
        isShowSport() {
            if (this.$store.getters.userInfo?.memberType === 'virtually') return false
            const msg = this.$store.state.system.betSportMsg
            return !!(msg && msg.brandId != null && msg.brandId !== '' && msg.gameInfoId != null && msg.gameInfoId !== '')
        },
        isIntoSport() {
            return this.$store.state.system.isShowSports
        }
    },
    created() {
        this.pathAct = this.$route.name
        // if (this.isLogin) getUserInfo()
    },
    mounted() {
        try {
            this.$nextTick(() => {
                window.addEventListener('beforeinstallprompt', function (e) {
                    // 阻止默认提示弹出
                    e.preventDefault()
                    // 把事件存起来
                    savedPwaPrompt888 = e
                })
            })
        } catch {
            console.log('error-pwa-不支持？不显示？')
        }
        if (this.$route.name === 'Sports') {
            this.$store.dispatch('system/setIsShowSport', true)
        }
    },
    methods: {
        getUserInfo() {
            this.isRefreshingMoney = true
            getUserInfo().finally(() => {
                this.isRefreshingMoney = false
            })
        },
        onMenuItem(act) {
            if (this.pathAct === act) {
                Toast(this.$t('lang.CurrentlyPage'))
                return
            }
            this.pathAct = act
            this.onNavTo({ url: act, type: 'post' })
        },
        toggleSideBar() {
            this.$store.dispatch('app/toggleSideBar')
        },
        toLogin(type) {
            this.$store.dispatch('user/changeLoginType', type)
            this.$store.dispatch('user/setIsShowLoginPopup', true)
        },
        handleLogout() {
            this.$refs.logoutPopup.open()
        },
        toMy() {
            this.$store.dispatch('user/setIsShowMyPopup', true)
        },
        // onShowDownAppPopup() {
        //     this.$store.dispatch('user/setIsShowDownAppPopup', true)
        // },
        onCloseDownAppNav() {
            this.$store.dispatch('system/setIsShowDownAppNav', 2)
        },
        onShowDownAppPopup() {
            if (this.sysPlatform === 'WebAndroidGame') {
                this.$store.dispatch('user/setIsShowDownAppPopup', true)
            }
            if (this.sysPlatform === 'Windows') {
                if ('serviceWorker' in navigator) {
                    try {
                        savedPwaPrompt888.prompt()
                        savedPwaPrompt888.userChoice.then(choiceResult => {
                            if (choiceResult.outcome === 'accepted') {
                                // this.isShowTipsPopup = true
                                // uni.reLaunch({
                                // 	url: '/pages/index/index'
                                // })
                            } else {
                                console.log('用户拒绝安装PWA--可打印')
                            }
                        })
                    } catch (e) {
                        console.log(e, 'error-pwa-不支持？不显示？')
                        // pwaIconShow.value = false
                    }
                } else {
                    console.log('当前设备不支持')
                }
            }
            // if (this.sysPlatform === 'ios') {
            //     this.$refs.pwaIosPopup.open()
            // }
        },
        toSearch() {
            this.$store.dispatch('user/setIsShowSearchPopup', true)
        },
        maskNumber(phoneNumber) {
            const str = phoneNumber.toString()
            if (str.length <= 4) {
                return str
            }
            const firstTwo = str.slice(0, 2)
            const lastTwo = str.slice(-2)
            return `${firstTwo}***${lastTwo}`
        },
        toDeposit() {
            if (this.$route.path.indexOf('/wallet') !== -1) {
                return
            }
            const params = { type: 'deposit' }
            this.onNavTo({ url: '/wallet', type: 'get', params })
        },
        toWithdraw() {
            const params = { type: 'Withdraw' }
            this.onNavTo({ url: '/wallet', type: 'get', params })
        },
        toNotification() {
            if (this.$route.path.indexOf('/notification') !== -1) {
                return
            }
            const params = { type: 1 }
            this.onNavTo({ url: '/notification', type: 'get', params })
        },
        toSports() {
            if (this.$route.path.indexOf('/Sports') !== -1) {
                return
            }
            this.$store.dispatch('system/setIsShowSport', true)
            this.onNavTo({
                url: 'Sports'
            })
        }
    }
}
</script>

<style scoped lang="scss">
.header-sports-tabs {
    display: flex;
    gap: 8px;
    margin-left: 16px;
    button {
        padding: 8px 14px;
        border: 1px solid var(--aurora-line);
        border-radius: 12px;
        background: var(--aurora-surface);
        color: var(--aurora-muted);
        cursor: pointer;
        &.act {
            color: var(--aurora-accent);
            background: var(--aurora-lilac);
        }
    }
}
@import '@/common/styles/viriables.scss';
.fixed-header {
    width: 100%;
    position: relative;
    z-index: 98;
    // box-shadow: 0 4px 20px #0006;
    background: var(--aurora-surface);

    .downApp {
        background: var(--aurora-soft-gradient);
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 .2rem;
        box-sizing: border-box;
        height: .9rem;
        position: relative;

        &>div.icon-close {
            position: absolute;
            top: 0;
            left: 0;
            background: var(--aurora-surface);
            border-bottom-right-radius: 100%;
            width: .53rem;
            height: .45rem;
            padding-right: .08rem;
            padding-bottom: .1rem;
            box-sizing: border-box;

            &>i {
                font-size: .2rem;
                font-weight: bold;
                color: var(--aurora-ink);
            }
        }

        &>div.tips {
            padding-left: .28rem;
            color: var(--aurora-ink);
            font-size: .28rem;

            .money {
                color: var(--aurora-accent);
                font-size: .3rem;
                font-weight: 700;
            }
        }

        &>div.btn {
            background: var(--aurora-primary-gradient);
            color: var(--aurora-on-primary);
            font-size: .18rem;
            line-height: .5rem;
            padding: .048rem .16rem;
            padding-right: .2rem;
            border-radius: .2rem;
            display: flex;
            align-items: center;

            &>i {
                margin-right: .08rem;
            }
        }
    }

    .pages-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0;
        height: 1.2rem;
        box-sizing: border-box;
        position: relative;
        padding-left: 300px;

        .area_left{
            position: absolute;
            left: .34rem;
            display: flex;
            align-items: center;
            z-index: 8;

            .icon_toggle{
                color: var(--aurora-muted);
                font-size: .48rem;
                margin-right: .16rem;
                transition: all .3s;
                width: .52rem;
                height: .52rem;
                vertical-align: middle;
                cursor: pointer;

                &.sidebarOpened{
                    transform: rotate(180deg);
                }
            }

            .down_box {
                background: var(--aurora-soft-gradient);
                padding: 4px 6px;
                border-radius: 8px;
                display: flex;
                align-items: center;
                cursor: pointer;
                width: 212px;
                text-align: left;

                .down_img{
                    width: .6rem;
                    height: .6rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 10px;
                    background: var(--aurora-surface);
                }

                img {
                    width: .4rem;
                    height: .4rem;
                    vertical-align: middle;
                }

                .down_info {
                    font-size: 13px;
                    color: var(--aurora-ink);
                    flex: 1;
                    margin-left: 0.12rem;
                    font-weight: bold;
                    line-height: 18px;

                    &> div:last-child {
                        line-height: 15px;
                        font-size: 12px;
                        color: var(--aurora-accent);
                    }
                }
            }
        }

        .search_btn{
            width: 150px;
            height: 44px;
            border: .02rem solid var(--aurora-line);
            border-radius: 10px;
            display: flex;
            align-items: center;
            color: var(--aurora-accent);
            cursor: pointer;
            margin-left: 20px;
            position: absolute;
            left: 320px;
            cursor: pointer;
            z-index: 7;

            .txt {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                // height: 44px;
                // line-height: 42px;
                font-size: 15px;
            }

            .iconfont {
                font-weight: bold;
                height: 44px;
                width: 38px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }

        &>div.icon_logo {
            position: absolute;
            height: 100%;
            left: calc(50% + 70px);
            transform: translateX(-50%);
            top: 0;
            z-index: 3;
            background: var(--aurora-soft-gradient);
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 0 0 70px 70px;
            cursor: pointer;
            padding: 0 60px;

            .logo {
                height: .78rem;
                width: auto;
                will-change: auto !important;
                cursor: pointer;
            }

            &.mobile_logo{
                width: auto !important;
                left: .76rem !important;
                transform: translate(0, -50%) !important;
                background: transparent;
                top: 50% !important;
                padding: 0;
                .logo {
                    height: .84rem !important;
                    filter: drop-shadow(0 0 .08rem var(--aurora-shadow-color));
                }
            }
        }

        .user_action {
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: relative;
            z-index: 2;
            margin: 0 auto;
            // max-width: 1414px;
            min-width: 720px;
            padding-left: 32px;
            padding-right: 32px;
            width: 100%;

            &>div:last-child {
                display: flex;
                align-items: center;
                justify-content: flex-end;
            }

            .user_info {
                display: flex;
                align-items: center;
                justify-content: space-between;
                min-width: 3.15rem;
                height: .76rem;
                padding: .06rem .08rem;
                border-radius: .16rem;
                overflow: hidden;
                box-sizing: border-box;
                background:
                    var(--aurora-soft-gradient);
                border: 1px solid var(--aurora-line);
                box-shadow: inset 0 1px 0 var(--aurora-shadow-color), 0 .06rem .14rem var(--aurora-shadow-color);

                .icon-shuaxin {
                    color: var(--aurora-ink);
                    font-size: .3rem;
                    // width: .45rem;
                    margin-right: .08rem;
                    text-align: center;

                    &.turning {
                        animation: rotateAni 0.2s linear infinite;
                    }

                    @keyframes rotateAni {
                        0% {
                            transform: rotate(0deg);
                        }

                        100% {
                            transform: rotate(-360deg);
                        }
                    }
                }

                .user_account,
                .user_money {
                    color: var(--aurora-ink);
                    padding: 0 .08rem;
                    border-radius: .2rem;
                    margin-top: 0;
                    font-size: .26rem;
                    font-weight: 700;
                    letter-spacing: .01rem;
                    white-space: nowrap;
                }

                .user_account {
                    color: var(--aurora-muted);
                }

                .deposit {
                    height: .6rem;
                    border-radius: .17rem;
                    background:
                        var(--aurora-primary-gradient);
                    color: var(--aurora-on-primary);
                    line-height: .6rem;
                    font-size: .5rem;
                    margin-left: .08rem;
                    cursor: pointer;
                    width: .66rem;
                    box-sizing: border-box;
                    position: relative;
                    overflow: hidden;

                    &:after {
                        content: "";
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        top: 0;
                        left: 0;
                        background-image: var(--aurora-primary-gradient);
                        background-repeat: no-repeat;
                        animation: bgmove-1badf8a4 linear 2.5s infinite;
                    }

                    @keyframes bgmove-1badf8a4 {
                        0% {
                            background-position: -200px 0
                        }

                        to {
                            background-position: 400px 0
                        }
                    }
                }
            }

            .user_info_pc{
                position: relative;
                cursor: pointer;
                background: var(--aurora-soft-gradient);
                border-radius: 30px;
                padding: 4px 7px 4px 4px;
                height: 48px;
                display: flex;
                align-items: center;
                box-sizing: border-box;
                gap: 0;

                .u_avatar{
                    border-radius: 25px;
                    margin-right: 8px;
                    height: 100%;
                    background: var(--aurora-surface);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 40px;
                    border-radius: 25px;
                    object-fit: contain;
                    vertical-align: middle;
                }
                .u-info{
                    line-height: 1.02;
                    font-size: 16px;
                    color: var(--aurora-ink);
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    min-width: 0;

                    & > div:first-child{
                        font-weight: 700;
                        white-space: nowrap;
                    }
                    & > div:last-child{
                        color: var(--aurora-accent);
                        font-size: 13px;
                        margin-top: 2px;
                        white-space: nowrap;
                    }
                }
                .u-arrow{
                    transform: rotate(-90deg);
                    width: 12px;
                    margin: 0 3px 0 6px;
                    border-style: none;
                    height: auto;
                    flex: none;
                }
            }

            .Notification {
                width: 46px;
                height: 46px;
                background: var(--aurora-soft-gradient);
                border-radius: 23px;
                margin: 0 0 0 7px;
                cursor: pointer;
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;

                &:hover {
                    background: var(--aurora-lilac);
                }

                &>i {
                    font-size: .36rem;
                    color: var(--aurora-ink);
                }

                .matterNumber{
                    position: absolute;
                    height: .36rem;
                    width: .36rem;
                    border-radius: 50px;
                    background: var(--aurora-surface);
                    color: var(--aurora-ink);
                    font-size: .26rem;
                    top:-.1rem;
                    right: -.1rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }

            .user_login {
                font-size: .26rem;
                height: .7rem;
                line-height: .7rem;
                display: flex;
                align-items: center;

                .login {
                    color: var(--aurora-ink);
                    cursor: pointer;
                    text-align: center;
                    padding: 0 .18rem;
                    border-radius: .1rem;
                    margin-right: .02rem;
                    border: .01rem solid var(--aurora-line);
                    background: var(--aurora-soft-gradient);
                }

                .sign_up {
                    color: var(--aurora-on-primary);
                    cursor: pointer;
                    text-align: center;
                    border-radius: .15rem;
                    padding: 0 .18rem;
                    background: var(--aurora-primary-gradient);
                    margin-right: .12rem;
                    font-weight: bold;

                }
            }
        }
    }
}

html[data-device-nodesktop="1"] {
    .fixed-header {
        z-index: 100;

        .downApp {
            display: none;
        }
    }
}
.fixed-header {
    background:
        var(--aurora-soft-gradient);
    box-shadow: inset 0 -1px 0 var(--aurora-shadow-color), 0 .08rem .22rem var(--aurora-shadow-color);

    .pages-header {
        background:
            var(--aurora-soft-gradient);
        border-top: 1px solid var(--aurora-line);
        border-bottom: 1px solid var(--aurora-line);
    }

    .pages-header .area_left .icon_toggle {
        padding: .08rem;
        background: var(--aurora-soft-gradient);
        border-radius: 50%;
        box-shadow: inset 0 1px 0 var(--aurora-shadow-color), 0 .05rem .12rem var(--aurora-shadow-color);
    }

    .pages-header .area_left .down_box,
    .pages-header .search_btn,
    .pages-header .user_info,
    .pages-header .user_login .login {
        background: var(--aurora-soft-gradient);
        border: 1px solid var(--aurora-line);
        box-shadow: inset 0 1px 0 var(--aurora-shadow-color), 0 .06rem .14rem var(--aurora-shadow-color);
    }

    .pages-header .area_left .down_box .down_img,
    .pages-header .user_info_pc .u_avatar {
        background: var(--aurora-soft-gradient);
    }

    .pages-header .area_left .down_box .down_info,
    .pages-header .search_btn,
    .pages-header .user_info_pc .u-info > div:first-child,
    .pages-header .user_info .user_money {
        color: var(--aurora-ink);
    }

    .pages-header .area_left .down_box .down_info > div:last-child,
    .pages-header .search_btn .txt,
    .pages-header .user_info_pc .u-info > div:last-child {
        color: var(--aurora-accent);
    }

    .pages-header > div.icon_logo {
        background: transparent;
        border: none;
        box-shadow: none;
    }

    .pages-header .search_btn {
        color: var(--aurora-ink);
    }

    .pages-header .search_btn .iconfont,
    .pages-header .user_info .icon-shuaxin {
        color: var(--aurora-ink);
    }

    .pages-header .user_info .deposit,
    .pages-header .user_login .sign_up {
        color: var(--aurora-on-primary);
        background:
            var(--aurora-primary-gradient);
        box-shadow: inset 0 1px 0 var(--aurora-shadow-color), 0 0 .14rem var(--aurora-shadow-color);
    }

    .pages-header .user_login .login {
        color: var(--aurora-ink);
        background: var(--aurora-soft-gradient);
        box-shadow: inset 0 1px 0 var(--aurora-shadow-color), inset 0 -.05rem .12rem var(--aurora-shadow-color);
    }

    .pages-header .user_info_pc,
    .pages-header .Notification {
        background:
            var(--aurora-soft-gradient);
        border: 1px solid var(--aurora-line);
        box-shadow: inset 0 1px 0 var(--aurora-shadow-color), 0 .06rem .12rem var(--aurora-shadow-color);
    }

    .pages-header .Notification > i {
        color: var(--aurora-ink);
    }

    .pages-header .user_info_pc .u-info > div:first-child,
    .pages-header .user_info_pc .u-info > div:last-child,
    .pages-header .user_info_pc .u-arrow {
        color: var(--aurora-ink);
    }

    .pages-header .user_info_pc .u-info > div:last-child {
        color: var(--aurora-accent);
    }

    .pages-header .Notification:hover,
    .pages-header .search_btn:hover,
    .pages-header .area_left .down_box:hover,
    .pages-header .user_info_pc:hover {
        filter: brightness(1.05);
    }
}

html[data-device-nodesktop="0"] {
    .fixed-header {
        .pages-header {
            min-height: 1.04rem;
            padding: .12rem .2rem;
            padding-left: 4.48rem;
            gap: .14rem;
            box-sizing: border-box;
        }

        .pages-header .area_left {
            left: .12rem;
            gap: .1rem;
            max-width: 4.08rem;
        }

        .pages-header .area_left .icon_toggle {
            width: .44rem;
            height: .44rem;
            padding: .07rem;
            flex: none;
        }

        .pages-header .area_left .down_box {
            height: .58rem;
            width: 3.62rem;
            padding: .05rem .16rem .05rem .1rem;
            border-radius: .14rem;
            gap: .08rem;
            box-sizing: border-box;
        }

        .pages-header .area_left .down_box .down_img {
            width: .42rem;
            height: .42rem;
            border-radius: .12rem;
            flex: none;
        }

        .pages-header .area_left .down_box .down_img img {
            width: .24rem;
            height: .24rem;
        }

        .pages-header .area_left .down_box .down_info {
            line-height: .96;
            min-width: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
        }

        .pages-header .area_left .down_box .down_info > div:first-child {
            font-size: .085rem;
            font-weight: 700;
            line-height: .96;
            letter-spacing: .002rem;
        }

        .pages-header .area_left .down_box .down_info > div:last-child {
            margin-top: .015rem;
            font-size: .065rem;
            line-height: .96;
            letter-spacing: .001rem;
        }

        .pages-header .search_btn {
            width: 2.18rem;
            height: .62rem;
            border-radius: .14rem;
            padding: 0 .18rem;
            margin-left: 0;
            flex: none;
            justify-content: flex-start;
            gap: .1rem;
            box-sizing: border-box;
        }

        .pages-header .search_btn .iconfont {
            font-size: .22rem;
            flex: none;
        }

        .pages-header .search_btn .txt {
            font-size: .14rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .pages-header > div.icon_logo {
            width: 3.9rem;
            height: .74rem;
            left: 50%;
            transform: translateX(-50%);
            top: .04rem;
            border-radius: 0;
            overflow: hidden;
        }

        .pages-header > div.icon_logo .logo {
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
            filter: drop-shadow(0 2px 4px var(--aurora-shadow-color));
        }

        .pages-header .user_action {
            flex: 1;
            display: flex;
            justify-content: flex-end;
            min-width: 0;
        }

        .pages-header .user_action > div:last-child {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: .1rem;
            min-width: 0;
        }

        .pages-header .user_info_pc {
            height: .62rem;
            padding: .04rem .08rem .04rem .05rem;
            border-radius: .14rem;
            box-sizing: border-box;
        }

        .pages-header .user_info_pc .u_avatar {
            width: .5rem;
            min-width: .5rem;
            height: .5rem;
            margin-right: .08rem;
            border-radius: 50%;
        }

        .pages-header .user_info_pc .u-info {
            font-size: .14rem;
            white-space: nowrap;
            min-width: 1.16rem;
            justify-content: center;
        }

        .pages-header .user_info_pc .u-info > div:last-child {
            margin-top: .03rem;
            font-size: .1rem;
        }

        .pages-header .user_info_pc .u-arrow {
            width: .12rem;
            margin: 0 .03rem 0 .05rem;
            opacity: .95;
            filter: brightness(2.4) saturate(.15);
        }

        .pages-header .Notification {
            width: .58rem;
            height: .58rem;
            min-width: .58rem;
            border-radius: 50%;
            margin: 0;
        }

        .pages-header .Notification > i {
            font-size: .22rem;
        }

        .pages-header .user_login {
            height: .62rem;
            line-height: .62rem;
            gap: .1rem;
        }

        .pages-header .user_login .sign_up,
        .pages-header .user_login .login {
            height: .62rem;
            line-height: .62rem;
            min-width: 1.34rem;
            padding: 0 .2rem;
            border-radius: .14rem;
            font-size: .23rem;
            font-weight: 700;
            margin-right: 0;
            box-sizing: border-box;
        }

        .pages-header .user_login .login {
            min-width: 1.48rem;
        }
    }
}

.fixed-header {
    background:
        var(--aurora-soft-gradient);
    border-bottom: 1px solid var(--aurora-line);
    box-shadow: inset 0 1px 0 var(--aurora-shadow-color);
}

.pages-header {
    background: transparent;
}

.pages-header .area_left .icon_toggle {
    background:
        var(--aurora-soft-gradient);
    box-shadow: inset 0 1px 0 var(--aurora-shadow-color), 0 .06rem .12rem var(--aurora-shadow-color);
}

.pages-header .area_left .down_box {
    background:
        var(--aurora-soft-gradient);
    border: 1px solid var(--aurora-line);
    box-shadow: inset 0 1px 0 var(--aurora-shadow-color), 0 .06rem .14rem var(--aurora-shadow-color);
}

.pages-header .area_left .down_box .down_img {
    background: var(--aurora-soft-gradient);
    border: 1px solid var(--aurora-line);
    box-shadow: inset 0 1px 0 var(--aurora-shadow-color);
}

.pages-header .area_left .down_box .down_info > div:first-child {
    color: var(--aurora-ink);
}

.pages-header .area_left .down_box .down_info > div:last-child {
    color: var(--aurora-accent);
}

.pages-header .search_btn {
    background:
        var(--aurora-soft-gradient);
    border: 1px solid var(--aurora-line);
    box-shadow:
        inset 0 1px 0 var(--aurora-shadow-color),
        0 0 .16rem var(--aurora-shadow-color),
        0 .04rem .1rem var(--aurora-shadow-color);
}

.pages-header > div.icon_logo {
    background:
        var(--aurora-soft-gradient);
    border-radius: 0 0 .34rem .34rem;
    box-shadow: inset 0 1px 0 var(--aurora-shadow-color), 0 .08rem .16rem var(--aurora-shadow-color);
}

.pages-header .user_login .sign_up {
    background:
        var(--aurora-primary-gradient);
    border: 1px solid var(--aurora-line);
    box-shadow:
        inset 0 1px 0 var(--aurora-shadow-color),
        0 0 .2rem var(--aurora-shadow-color),
        0 .06rem .14rem var(--aurora-shadow-color);
}

.pages-header .user_login .login,
.pages-header .user_info_pc,
.pages-header .Notification {
    background:
        var(--aurora-soft-gradient);
    border: 1px solid var(--aurora-line);
    box-shadow:
        inset 0 1px 0 var(--aurora-shadow-color),
        0 .05rem .12rem var(--aurora-shadow-color);
}

.pages-header .user_login .login:hover,
.pages-header .user_info_pc:hover,
.pages-header .Notification:hover {
    border-color: var(--aurora-accent);
    box-shadow:
        inset 0 1px 0 var(--aurora-shadow-color),
        0 0 .18rem var(--aurora-shadow-color),
        0 .05rem .12rem var(--aurora-shadow-color);
}

.pages-header .Notification > i,
.pages-header .user_info_pc .u-info > div:first-child,
.pages-header .user_info_pc .u-arrow {
    color: var(--aurora-ink);
}

.pages-header .user_info_pc .u-info > div:last-child,
.pages-header .search_btn .txt {
    color: var(--aurora-muted);
}

.pages-header .user_login .login {
    color: var(--aurora-ink);
}

.fixed-header .pages-header .user_info_pc,
.fixed-header .pages-header .Notification {
    background:
        var(--aurora-soft-gradient) !important;
    border: 1px solid var(--aurora-line) !important;
    box-shadow:
        inset 0 1px 0 var(--aurora-shadow-color),
        0 .05rem .12rem var(--aurora-shadow-color) !important;
}

.fixed-header .pages-header .user_info_pc .u-info > div:first-child,
.fixed-header .pages-header .Notification > i,
.fixed-header .pages-header .user_info_pc .u-arrow {
    color: var(--aurora-ink) !important;
}

.fixed-header .pages-header .user_info_pc .u-info > div:last-child {
    color: var(--aurora-muted) !important;
}

@media screen and (max-width: 767px) {
    .pages-header .area_left .icon_toggle {
        width: .56rem !important;
        height: .56rem !important;
        padding: .1rem !important;
        box-sizing: border-box;
    }

    .pages-header {
        padding-left: 0 !important;
        justify-content: space-between;
    }

    .pages-header .area_left {
        left: .12rem !important;
        z-index: 4;
    }

    .pages-header .user_action {
        width: 100%;
        padding-left: 2.18rem;
        box-sizing: border-box;
    }

    .pages-header .user_action > div:first-child {
        display: none;
    }

    .pages-header .user_action > div:last-child {
        width: 100%;
        justify-content: flex-end;
        gap: .1rem;
        padding-right: 0;
        box-sizing: border-box;
    }

    .pages-header .user_info {
        min-width: 0 !important;
        width: auto !important;
        max-width: calc(100vw - 2.26rem) !important;
        height: .64rem !important;
        padding: .05rem .07rem .05rem .1rem !important;
        border-radius: .16rem !important;
        background:
            var(--aurora-soft-gradient) !important;
        border: 1px solid var(--aurora-line) !important;
        box-shadow:
            inset 0 1px 0 var(--aurora-shadow-color),
            0 .05rem .12rem var(--aurora-shadow-color) !important;
    }

    .pages-header .user_info .user_money {
        flex: 1;
        min-width: 0;
        margin-top: 0 !important;
        padding: 0 .01rem !important;
        color: var(--aurora-ink) !important;
        font-size: .23rem !important;
        line-height: .54rem !important;
        font-weight: 700 !important;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        background: transparent !important;
    }

    .pages-header .user_info .deposit {
        width: .54rem !important;
        min-width: .54rem !important;
        height: .54rem !important;
        line-height: .43rem !important;
        margin-left: .05rem !important;
        border-radius: .16rem !important;
        font-size: .38rem !important;
        background:
            var(--aurora-primary-gradient) !important;
        color: var(--aurora-on-primary) !important;
        border: 1px solid var(--aurora-line) !important;
        box-shadow: inset 0 1px 0 var(--aurora-shadow-color), 0 .05rem .12rem var(--aurora-shadow-color) !important;
    }

    .pages-header .Notification {
        width: .6rem !important;
        height: .62rem !important;
        min-width: .6rem !important;
    }

    .pages-header .Notification > i {
        font-size: .24rem !important;
    }
}

.pages-header .user_wrap .user_info,
.pages-header .area_right .user_info {
    background:
        var(--aurora-soft-gradient) !important;
    border-color: var(--aurora-line) !important;
    box-shadow: inset 0 1px 0 var(--aurora-shadow-color), 0 .08rem .18rem var(--aurora-shadow-color) !important;
}

.pages-header .user_wrap .Notification,
.pages-header .area_right .Notification {
    background:
        var(--aurora-soft-gradient) !important;
    border-color: var(--aurora-line) !important;
}
</style>
